<form
  [formGroup]="updateProductTypeForm"
  (ngSubmit)="onUpdateProductType()"
  #pTypeForm
>
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button
        class="main-btn"
        type="submit"
        [ngClass]="{ disabled: !updateProductTypeForm.valid }"
        [disabled]="!updateProductTypeForm.valid"
      >
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <h3 class="card-title">Izmeni tip</h3>
    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field">
            <label>Naziv tipa</label>
            <section class="flex align-items-center">
              <input type="text" formControlName="name" pInputText />
              <button
                class="second-btn small-btn ml-3"
                type="button"
                pTooltip="Izbriši"
                tooltipPosition="top"
                (click)="onDeleteProductType($event)"
              >
                <i class="pi pi-trash"></i>
              </button>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
